import { useEffect, useCallback } from 'react';
import { useTheme } from '../../../contexts/ThemeContext';
import { lightTheme } from '../../theme/types/light-theme.type';
import { darkTheme } from '../../theme/types/dark-theme.type';
import AppGetIcon from '../AppGetIcon';

type ThemeSwitcherProps = {
  showLabel?: boolean;        // Muestra texto junto al icono
  ariaLabel?: string;         // Accesibilidad
  className?: string;         // Para ubicar/estilar libremente
  withShortcutHint?: boolean; // Muestra tooltip/label del atajo
};

export default function ThemeSwitcher({
  showLabel = false,
  ariaLabel = 'Cambiar tema',
  className = '',
  withShortcutHint = false,
}: ThemeSwitcherProps) {
  const { theme, setTheme } = useTheme();
  const isDark = theme?.name === 'dark';

  const toggle = useCallback(() => {
    setTheme(isDark ? lightTheme : darkTheme);
  }, [isDark, setTheme]);

  // Atajo de teclado: Alt+T
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.altKey && (e.key.toLowerCase() === 't')) {
        e.preventDefault();
        toggle();
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [toggle]);

  return (
    <button
      type="button"
      onClick={toggle}
      className={`theme-switcher-btn ${className}`}
      aria-label={ariaLabel}
      title={withShortcutHint ? `${isDark ? 'Modo claro' : 'Modo oscuro'} (Alt+T)` : (isDark ? 'Modo claro' : 'Modo oscuro')}
    >
      <AppGetIcon
        name={isDark ? 'sun' : 'moon'}
        classIcon="size-icon-sidebar"
        fillColor="var(--color-on-surface-variant-main)"
      />
      {showLabel && (
        <span style={{ marginLeft: 8 }}>
          {isDark ? 'Modo claro' : 'Modo oscuro'}
        </span>
      )}
    </button>
  );
}
